<template>
	<div class="tab-pane" id="overview">
		<h3 class="info-text mb-0">Overview &amp; Finalize</h3>
		<p class="text-center text-secondary mb-4">
			<em>Please review carefully for accuracy!</em>
		</p>
		<div class="row justify-content-center">
			<div class="col-12 pr-5 pl-5">

        <div class="row">
          <div class="col-12">
            <div class="alert alert-danger">
              <span>
                <strong> <i class="fa fa-warning mr-2 fs-20" /> Alert - </strong>
                <span>
                  You are one step away from completing your migration request! Please review your submitted information and click submit to proceed.
                </span>
              </span>
            </div>
          </div>
        </div>
				<div class="row">
					<div class="col-12">
						<div class="selected-plan center">
							<span class="badge badge-success mr-2">Selected Plan</span> <strong class="align-middle">{{selectedPlanFullName }}</strong>
						</div>
					</div>
					<div class="col-12">
						<span style="font-size: 1.3em;"><i class="nc-icon nc-world-2 text-secondary align-middle mr-2"></i>
							<strong class="align-middle">Site Details</strong></span>
						<hr>
						<div class="row" v-for="(acc, index) in migrationList" :key="index">
							<div class="col-sm-12 col-md-4">
								<span class="text-secondary d-block">Domain Name</span>
								<strong class="d-block text-danger">{{ acc.domain }}</strong>
							</div>
							<!-- If user enter teh hosting details - start -->
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.hostSameAsAbove">
								<span class="text-secondary d-block">Current Host</span>
								<span class="d-block">{{ acc.currentHost.name }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.hostSameAsAbove">
								<span class="text-secondary d-block">Hosting Panel URL</span>
								<span class="d-block">{{ acc.currentHost.url }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.hostSameAsAbove">
								<span class="text-secondary d-block">Hosting Panel Username</span>
								<span class="d-block">{{ acc.currentHost.username }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.hostSameAsAbove">
								<span class="text-secondary d-block">Hosting Panel Password</span>
								<span class="d-block">{{ acc.currentHost.password }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4">
								<span class="text-secondary d-block">WordPress Admin Username</span>
								<span class="d-block">{{ acc.wpAdminDetails.username }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4">
								<span class="text-secondary d-block">WordPress Admin Password</span>
								<span class="d-block">{{ acc.wpAdminDetails.password }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4">
								<span class="text-secondary d-block">WordPress Admin Login URL</span>
								<span class="d-block">{{ acc.wpAdminDetails.loginURL }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.hostSameAsAbove && acc.haveSSH">
								<span class="text-secondary d-block">SSH IP</span>
								<span class="d-block">{{ acc.ssh.ip }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.hostSameAsAbove && acc.haveSSH">
								<span class="text-secondary d-block">SSH Port</span>
								<span class="d-block">{{ acc.ssh.port }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.hostSameAsAbove && acc.haveSSH">
								<span class="text-secondary d-block">SSH Username</span>
								<span class="d-block">{{ acc.ssh.username }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.hostSameAsAbove && acc.haveSSH">
								<span class="text-secondary d-block">SSH Password</span>
								<span class="d-block">{{ acc.ssh.password }}</span>
							</div>
							<!-- If user enter teh hosting details - end -->
							<!-- If user selected the hosting details same as above - start -->
							<div class="col-sm-12 col-md-4 mb-4" v-if="acc.hostSameAsAbove">
								<span class="text-secondary d-block">Current Host</span>
								<span class="d-block">Same as {{ migrationList[0].domain }} details</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="acc.hostSameAsAbove">
								<span class="text-secondary d-block">Hosting Panel URL</span>
								<span class="d-block">Same as {{ migrationList[0].domain }} details</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="acc.hostSameAsAbove">
								<span class="text-secondary d-block">Hosting Panel Username</span>
								<span class="d-block">Same as {{ migrationList[0].domain }} details</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="acc.hostSameAsAbove">
								<span class="text-secondary d-block">Hosting Panel Password</span>
								<span class="d-block">Same as {{ migrationList[0].domain }} details</span>
							</div>
<!--							<div class="col-sm-12 col-md-4 mb-4" v-if="acc.hostSameAsAbove">-->
<!--								<span class="text-secondary d-block">WordPress Admin Username</span>-->
<!--								<span class="d-block">Same as {{ migrationList[0].domain }} details</span>-->
<!--							</div>-->
<!--							<div class="col-sm-12 col-md-4 mb-4" v-if="acc.hostSameAsAbove">-->
<!--								<span class="text-secondary d-block">WordPress Admin Password</span>-->
<!--								<span class="d-block">Same as {{ migrationList[0].domain }} details</span>-->
<!--							</div>-->
<!--							<div class="col-sm-12 col-md-4 mb-4" v-if="acc.hostSameAsAbove">-->
<!--								<span class="text-secondary d-block">WordPress Admin Login URL</span>-->
<!--								<span class="d-block">Same as {{ migrationList[0].domain }} details</span>-->
<!--							</div>-->
							<div class="col-sm-12 col-md-4 mb-4" v-if="acc.hostSameAsAbove && migrationList[0].haveSSH">
								<span class="text-secondary d-block">SSH Details</span>
								<span class="d-block">Same as {{ migrationList[0].domain }} details</span>
							</div>
							<!-- If user selected the hosting details same as above - end -->
							<div class="col-12" v-if="index < (migrationList.length - 1)">
								<hr class="color-line mb-4 mt-0">
							</div>
						</div>
						<!-- Domain Details Section - Start -->
						<span style="font-size: 1.3em;"><i class="nc-icon nc-app text-secondary align-middle mr-2"></i> <strong
								class="align-middle">Domain Details</strong></span>
						<hr>
						<p class="text-danger" style="font-size: 18px;" v-if="!dnsManagedByBigscoots">
							<strong><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Please Note</strong>
							You have selected to manage the DNS yourself. The DNS changes will have to be implemented
							quickly by you once the migration has completed to avoid possible data loss.
						</p>
						<div class="row" v-for="(acc, index) in migrationList" :key="`domainReg${index}`" v-else>
							<div class="col-sm-12 col-md-4 mb-4">
								<span class="text-secondary d-block">Domain Name</span>
								<strong class="d-block text-danger">{{ acc.domain }}</strong>
							</div>
							<!-- Section for showing if domain register details have been enetered - start -->
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.domainRegSameAsHost">
								<span class="text-secondary d-block">Domain Registar Name</span>
								<span class="d-block">{{ acc.domainRegistar.name }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.domainRegSameAsHost">
								<span class="text-secondary d-block">Domain Registar URL</span>
								<span class="d-block">{{ acc.domainRegistar.url }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.domainRegSameAsHost">
								<span class="text-secondary d-block">Domain Registar Username</span>
								<span class="d-block">{{ acc.domainRegistar.username }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="!acc.domainRegSameAsHost">
								<span class="text-secondary d-block">Domain Registar Password</span>
								<span class="d-block">{{ acc.domainRegistar.password }}</span>
							</div>
							<!-- Section for showing if domain register details have been enetered - end -->
							<!-- Section for if domain register is same has host - start -->
							<div class="col-sm-12 col-md-4 mb-4" v-if="acc.domainRegSameAsHost">
								<span class="text-secondary d-block">Domain Registar Details</span>
								<span class="d-block">Same as the hosting login details</span>
							</div>
							<!-- Section for if domain register is same has host - end -->
							<div class="col-12" v-if="index < (migrationList.length - 1)">
								<hr class="color-line mb-4 mt-0">
							</div>
						</div>
						<!-- Domain Details Section - End -->
						<!-- Additional Details Section - Start -->
						<span style="font-size: 1.3em;"><i class="nc-icon nc-atom text-secondary align-middle mr-2"></i> <strong
								class="align-middle">Additional Details</strong></span>
						<hr>
						<div class="row">
							<div class="col-sm-12 col-md-4 mb-4">
								<span class="text-secondary d-block">Have Cloudflare, Sucuri or Other DNS/CDN Account?</span>
								<span class="d-block">{{ haveCloudflare ? "Yes" : "No" }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="haveCloudflare">
								<span class="text-secondary d-block">DNS / CDN Service</span>
								<span class="d-block">{{ cdnType }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="haveCloudflare">
								<span class="text-secondary d-block">Email / Username</span>
								<span class="d-block">{{ cfEmail }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="haveCloudflare">
								<span class="text-secondary d-block">Password</span>
								<span class="d-block">{{ cfPass }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4">
								<span class="text-secondary d-block">Will we be migrating anything with membership or ecommerce?</span>
								<span class="d-block">{{ isMAndC ? "Yes" : "No" }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="shouldAddCollaborator">
								<span class="text-secondary d-block">Assigned Collaborators:</span>
								<span v-for="collaborator in addedCollaborators" class="badge badge-primary mr-2">{{collaborator}}</span>
								<span class="d-block" v-if="addedCollaborators.length === 0">N/A</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4">
								<span class="text-secondary d-block">Special .htaccess or nginx rewrite rules or instructions</span>
								<p class="d-block mb-0" v-if="haveSpecialRewriteRule">{{ rewriteRule }}</p>
								<span class="d-block" v-else>N.A.</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4">
								<span class="text-secondary d-block">Any other special instructions</span>
								<p class="d-block mb-0">{{ (specialInstruction === "") ? "N.A." : specialInstruction }}</p>
							</div>
						</div>
						<!-- Additional Details Section - End -->
						<!-- Email Section - Start -->
						<span style="font-size: 1.3em;"><i
								class="nc-icon nc-email-85 text-secondary align-middle mr-2"></i> <strong
								class="align-middle">Email Details</strong></span>
						<hr>
						<div class="row">
							<div class="col-sm-12 col-md-4 mb-4">
								<span class="text-secondary d-block">Do you want BigScoots to provide email service?</span>
								<span class="d-block">{{ useEmailOnDomain ? "Yes" : "No" }}</span>
							</div>
							<!--
							<div class="col-sm-12 col-md-4 mb-4" v-if="useEmailOnDomain">
								<span class="text-secondary d-block">If you use GSuite, Office365, Zoho Mail or another third party email service, do you intend on keeping it?</span>
								<span class="d-block">{{ haveGsuite ? "Yes" : "No" }}</span>
							</div>
							-->
							<div class="col-sm-12 col-md-4 mb-4" v-if="useEmailOnDomain && !haveGsuite">
								<span class="text-secondary d-block">Would you like BigScoots to provide you with email service?</span>
								<span class="d-block">{{ moveEmailToBigscoots ? "Yes" : "No" }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="useEmailOnDomain && alternateEmail">
								<span class="text-secondary d-block">Alternate email for communication:</span>
								<span class="d-block">{{ alternateEmail }}</span>
							</div>
							<div class="col-sm-12 col-md-4 mb-4" v-if="useEmailOnDomain && !haveGsuite">
								<span class="text-secondary d-block">Extra details or special request for email</span>
								<p class="d-block mb-0">{{ emailSpecialRequest === "" ? "N.A." : emailSpecialRequest }}</p>
							</div>
						</div>
						<!-- Email Section - End -->
						<!-- Cost and Final Submissition Section - Start -->
						<hr class="color-line">
						<p class="text-danger text-center" style="font-size: 2em;">
							<strong>Total Migration Cost: {{ migrationCost }}</strong>
						</p>
						<button class="btn btn-lg btn-primary w-100" :disabled="loading" @click.prevent="submitMigration">
							<div class="loader small_loader" v-if="loading"></div>
							<span v-else>Submit Migration Request</span>
						</button>
						<!-- Cost and Final Submissition Section - End -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from "sweetalert2"
	import { db, functions } from '@/firebase/init'
	import crypto from 'crypto-js';
	export default {
		name: "OverviewAndFinalize",
		data: function () {
			return {
				loading: false
			};
		},
		props: {
			supervisorUID: {
				type: String
			},
			collaboration: {
				type: Boolean,
				default() {return false;}
			},
			supervisor: {
				type: Object,
				default() {return {};}
			}
		},
		computed: {
			shouldAddCollaborator () {
				return this.$store.getters["migration/shouldAddCollaborator"];
			},
			addedCollaborators () {
				return this.$store.getters["migration/getAddedCollaborators"];
			},
			planIndex() {
				return this.$store.getters["migration/planIndex"];
			},
			hostingAccounts() {
				return this.$store.getters["hosting/accounts"]
			},
			hostingAccountsOrdered() {
				return this.$store.getters["hosting/accountsOrdered"]
			},
			selectedPlanFullName() {
				if (typeof this.planIndex === "number") {
					const plans = this.hostingAccounts;
					if(plans === undefined || plans.length <= 0){
						return null;
					}
					const selectedPlanFullName = `${plans[this.planIndex].planName} - ${
						plans[this.planIndex].primary.domain
						}`;
					return selectedPlanFullName;
				} else {
					return null;
				}
			},
			migrationList() {
				return this.$store.getters["migration/migrationList"]
			},
			dnsManagedByBigscoots() {
				return this.$store.getters["migration/dnsByBigscoots"]
			},
			haveCloudflare() {
				return this.$store.getters["migration/haveCloudflare"]
			},
			cdnType () {
				return this.$store.getters["migration/cdnType"];
			},
			cfEmail() {
				return this.$store.getters["migration/cfEmail"]
			},
			cfPass() {
				return this.$store.getters["migration/cfPass"]
			},
			haveSpecialRewriteRule() {
				return this.$store.getters["migration/haveSpecialRewriteRule"]
			},
			rewriteRule() {
				return this.$store.getters["migration/rewriteRule"]
			},
			specialInstruction() {
				return this.$store.getters["migration/specialInstruction"]
			},
			useEmailOnDomain() {
				return this.$store.getters["migration/useEmailOnDomain"]
			},
			isMAndC() {
				return this.$store.getters["migration/isMAndC"];
			},
			mOrC() {
				return this.$store.getters["migration/mOrC"];
			},
			haveGsuite() {
				return this.$store.getters["migration/haveGsuite"]
			},
			moveEmailToBigscoots() {
				return this.$store.getters["migration/moveEmailToBigscoots"]
			},
			emailSpecialRequest() {
				return this.$store.getters["migration/emailSpecialRequest"]
			},
			alternateEmail() {
				return this.$store.getters["migration/alternateEmail"];
			},
			selectedPlanName() {
				if (typeof this.planIndex === "number") {
					const plans = this.hostingAccounts;
					if(plans === undefined || plans.length <= 0){
						return null;
					}
					const selectedPlanFullName = plans[this.planIndex].planName;
					const temp = selectedPlanFullName.split(" ");
					const selectedPlanShortName = temp[1].toLowerCase().trim();
					return selectedPlanShortName;
				} else {
					return null;
				}
			},
			migrationFreeLimit() {
				const allMigrationLimit = this.$store.getters["migration/limit"];
				if(this.planIndex !== null && this.hostingAccounts.length > 0 && this.hostingAccounts[this.planIndex].maxMigrations){
					return this.hostingAccounts[this.planIndex].maxMigrations;
				}
				// Loop through the received object to get the limit for our selected plan
				for (const key in allMigrationLimit) {
					if (this.selectedPlanName === key) {
						return allMigrationLimit[key];
					}
				}
			},
			migrationTotalCount() {
				return this.$store.getters["migration/count"]
			},
			savedMigrationCount() {
				return this.$store.getters["migration/savedMigrationCount"]
			},
			migrationCost() {
				const totalMigrationCount = this.migrationTotalCount
				const savedMigrationCount = this.savedMigrationCount
				const migrationLimit = this.migrationFreeLimit
				let extra;
				if (savedMigrationCount<= migrationLimit) {
					 extra = (totalMigrationCount - migrationLimit)
				} else extra = (totalMigrationCount - savedMigrationCount)

				if (extra > 0) {
					return `$${extra * 25}`
				} else {
					return "Free"
				}
			},
			clientID() {
				return this.$store.getters.getRequestCustomerID
				// return this.$store.getters.getCustomerID
			},
			userUID() {
				return this.$store.getters.getUID
			},
			user() {
				return this.$store.getters.user;
			},
			addOnCount(){
				return this.$store.getters['migration/addonCount'];
			},
			addOnLimit(){
				return this.$store.getters['migration/addonLimit'];
			},
			aesSecret() {
				return this.$store.getters["crypto/aesSecret"];
			}
		},
		methods: {
			async addCollaborators () {
				const selectedDomains = [];
				this.migrationList.forEach(async acc => {
					selectedDomains.push(acc.domain);
				});
				console.log('Domains to be assigned: ');
				console.log(selectedDomains);
				for (const collaboratorEmail of this.addedCollaborators) {
					let isSignUp = '0';
					let collabUid = '';
					let collabName = '';
					let collabSupervisors = null;
					const userUID = (this.collaboration) ? this.supervisorUID : this.user.uid;
					const supervisorName = (this.collaboration) ? this.supervisor.supervisorName : this.user.firstName + ' ' + this.user.lastName;
					const isUserExist = await db.collection('users').where('email', '==', collaboratorEmail).get();
					if(isUserExist.empty){
						isSignUp = '1';
					}else{
						console.log('Collab exist');
						isUserExist.forEach(doc => {
							collabUid = doc.id;
							collabName = doc.data()['firstName'] + ' ' + doc.data()['lastName'];
							collabSupervisors = doc.data()['supervisors'];
						});
						if(collabSupervisors === undefined){
							collabSupervisors = [];
						}
						const isSupervisorExist = collabSupervisors.find(supervisor => supervisor.supervisorId === userUID);
						if(isSupervisorExist) {
							console.log('Supervisor is already exist...');
							isSupervisorExist.allowedDomains = [...isSupervisorExist.allowedDomains, ...selectedDomains];
							console.log(collabSupervisors);
						} else {
							collabSupervisors.push({
								supervisorId: userUID,
								allowedDomains: selectedDomains,
								accessLevels: ['full'],
								allowAll: false,
								created: new Date().toISOString(),
								supervisorEmail: this.user.email,
								supervisorName: supervisorName,
								status: 'pending'
							});
						}
						await db.collection('users').doc(collabUid).update({
							supervisors: collabSupervisors
						});
					}
					console.log('IsIgnUp: ' + isSignUp);
					await db.collection('users').doc(userUID).get().then(async (doc) => {
						const userData = doc.data();
						if(userData.collaborators === undefined){
							userData.collaborators = []
						}
						const isCollaboratorExist = userData.collaborators.find(collaborator => collaborator.uid === collabUid);
						if(isCollaboratorExist) {
							console.log('Collaborator is already exist...');
							isCollaboratorExist.domains = [...isCollaboratorExist.domains, ...selectedDomains];
							console.log(userData.collaborators);
						} else {
							userData.collaborators.push({
								email: collaboratorEmail,
								uid: collabUid,
								name: collabName,
								domains: selectedDomains,
								accessLevels: ["full"],
								allowAll: false,
								created: new Date().toISOString(),
								status: 'pending'
							});
						}
						await db.collection('users').doc(userUID).update(userData);
						await this.$http.post('/collaborator/send_request', {
							grant_type: "token",
							collaborator: {
								email: collaboratorEmail,
								collaboratorName: (isSignUp === '0') ? collabName : '',
								uid: collabUid,
								domains: selectedDomains,
								created: new Date().toISOString(),
								status: 'pending'
							},
							signUpHref: 'https://' + window.location.hostname + '/signup/' +
									crypto.AES.encrypt(userUID, this.aesSecret).toString().split('/').join('Por21Ld') + '/'
									+ crypto.AES.encrypt(collaboratorEmail, this.aesSecret).toString().split('/').join('Por21Ld'),
							supervisorName: supervisorName,
							loginHref: 'https://' + window.location.hostname,
							isLogin: (isSignUp === '0') ? '1' : '0'
						}).then(() => {
							console.log('Collaborators has been added successfully to: ' + collaboratorEmail);
						}).catch(e => {
							console.error(e);
							console.error('There is something wrong in adding collaborators! Please contact support team');
						})
					});
				}
			},
			async udateCf (cfDomainList) {
				if (this.haveCloudflare && this.cdnType === 'Cloudflare' && this.cfEmail && this.cfPass) {
					console.log('api call to save given credentials')
					try {
						await this.$http.post('/domain/update-cloudflare-credentials', {
							grant_type: "token",
							cfDomainList,
							cfEmail: this.cfEmail,
							cfPass: this.cfPass,
							uid: (this.collaboration) ? this.supervisorUID : this.userUID
						})
					} catch (e) {
						console.log('error in updating cloudflare credentials')
						console.log(e.toString())
					}
				}
			},
			async getChecklist (domain) {
				const settings = await db.collection('permissions').doc('migration-checklist').get()
				let checklist = settings.data().checklist
				checklist = JSON.stringify(checklist)
				checklist = checklist.replace(/{domainName}/g, domain)
				checklist = JSON.parse(checklist)
				return checklist
			},
			async submitMigration() {
				// Set asyncDone to false
				const userUID = (this.collaboration) ? this.supervisorUID : this.user.uid;
				this.loading = true;

				const migrationDomainList = [];
				const cfDomainList = [];

				for (let acc of this.migrationList) {
					let isPrimaryDomain = false;
					this.hostingAccountsOrdered.forEach((accountOrdered) => {
						if (acc.domain === accountOrdered.domain && accountOrdered.type === 'Primary Domain') {
              isPrimaryDomain = true;
            }
					});
					let isDomainChargeable = false;
					if(!isPrimaryDomain){
						isDomainChargeable = ((this.addOnLimit - this.addOnCount) <= 0);
					}
					const siteDetails = {
						domainName: acc.domain,
						isOldHosting: (acc.hostSameAsAbove),
						currentHost: (acc.hostSameAsAbove) ? this.migrationList[0].currentHost.name : acc.currentHost.name,
						hostingPanelLogin: (acc.hostSameAsAbove) ? this.migrationList[0].currentHost.url : acc.currentHost.url,
						hostingPanelUsername: (acc.hostSameAsAbove) ? this.migrationList[0].currentHost.username : acc.currentHost.username,
						hostingPanelPassword: (acc.hostSameAsAbove) ? this.migrationList[0].currentHost.password : acc.currentHost.password,
						wpAdminUsername: acc.wpAdminDetails.username,
						wpAdminPassword: acc.wpAdminDetails.password,
						wpAdminLogin: acc.wpAdminDetails.loginURL,
						isSSH: (acc.hostSameAsAbove) ? this.migrationList[0].haveSSH : acc.haveSSH,
						sshIP: (acc.hostSameAsAbove) ? this.migrationList[0].ssh.ip : acc.ssh.ip,
						sshPort: (acc.hostSameAsAbove) ? this.migrationList[0].ssh.port : acc.ssh.port ,
						sshUsername: (acc.hostSameAsAbove) ? this.migrationList[0].ssh.username : acc.ssh.username ,
						sshPassword: (acc.hostSameAsAbove) ? this.migrationList[0].ssh.password : acc.ssh.password
					};

					let domainRegistrarDetails = {};
					if (this.dnsManagedByBigscoots) {
						domainRegistrarDetails = {
							domainName:acc.domain,
							isRegistrarSame: (acc.domainRegSameAsHost),
							currentHost: (acc.domainRegSameAsHost) ? acc.currentHost.name : acc.domainRegistar.name,
							hostingPanelLogin: (acc.domainRegSameAsHost) ? acc.currentHost.url : acc.domainRegistar.url,
							hostingPanelUsername: (acc.domainRegSameAsHost) ? acc.currentHost.username : acc.domainRegistar.username,
							hostingPanelPassword: (acc.domainRegSameAsHost) ? acc.currentHost.password : acc.domainRegistar.password,
						};
					}
					const domainDetails = {
						handleDNS: (this.dnsManagedByBigscoots),
						domainRegistrarDetails
					};


					const additionalDetails = {
						isCF: this.haveCloudflare,
						cdnType: this.cdnType,
						cfUsername: (this.haveCloudflare) ? this.cfEmail : '',
						cfPassword: (this.haveCloudflare) ? this.cfPass : '',
						membershipOrECommerce: this.isMAndC,
						isWebsiteRedirectsAvailable: this.haveSpecialRewriteRule,
						websiteRedirects: (this.haveSpecialRewriteRule) ? this.rewriteRule : 'N/A',
						specialInstructions: (this.specialInstruction === '') ? 'N/A' : this.specialInstruction,
						collaborators: this.addedCollaborators
					};

					const emailDetails = {
						isEmail: this.useEmailOnDomain,
						alternateEmail: this.alternateEmail ? this.alternateEmail : 'N/A'
					};
					const checklist = await this.getChecklist(acc.domain)

					const docRef = await db.collection('savedMigrations').add({
						selectedPlan: {
							planName: this.selectedPlanFullName
						},
						siteDetails,
						domainDetails,
						additionalDetails,
						emailDetails,
						isDomainChargeable,
						isMigrationChargeable: acc.chargable,
						status: 'pending',
						cloudflare: {
							cf: false,
							ssl: false,
						},
						created: new Date().toISOString(),
						modified: new Date().toISOString(),
						handledBy: '',
						checkList: checklist,
						uid: userUID,
						email: this.user.email,
						primaryPlan: (typeof this.planIndex === "number")? this.hostingAccounts[this.planIndex].planName : null,
						sendTicketReply: true
					});

          await this.addLog({
            primaryPlan: (typeof this.planIndex === "number") ? this.hostingAccounts[this.planIndex].primary.domain : null,
            message: `Migration Request for the ${acc.domain} has been successfully saved in WPO.`,
            level: "info"
          });
					migrationDomainList.push({
						domain: acc.domain,
						chargable: acc.chargable,
						isDomainChargeable,
						docId: docRef.id
					});
					cfDomainList.push(acc.domain)
				}
				this.$http.post('/migration/addMigrationRequest', {
                    clientID: this.clientID,
					grant_type: 'token',
					customerUID: (this.collaboration) ? this.supervisorUID : this.userUID,
					planIndex: this.planIndex,
					planFullName: this.selectedPlanFullName,
					migrationDomainNameList: migrationDomainList,
					migrationTotalCount: this.migrationTotalCount,
					cc: (this.collaboration) ? this.user.email : '',
					submitterName: this.user.firstName + ' ' + this.user.lastName
				}).then(async result => {
							// Set asyncDone to true
							this.$store.dispatch("async/stateUpdate", {state: true})

							if (result.data.success === true) {
								// Refetch the hosting account details
								if(this.collaboration) {
									this.$store.dispatch("hosting/fetchAccounts", {UID: this.supervisorUID, allowedDomains: this.supervisor.allowedDomains});
								}else{
									this.$store.dispatch("hosting/fetchAccounts")
								}
								await this.addCollaborators();
								// call function to update cf
								await this.udateCf(cfDomainList);
                this.addLog({
								  primaryPlan: (typeof this.planIndex === "number")? this.hostingAccounts[this.planIndex].primary.domain : null,
								  message: `Tickets has been generated successfully of migration(s): (${cfDomainList.join()})`,
								  level: "info"
                });
								swal({
									title: "Migration Request Received!",
									text: result.data.message,
									type: "success",
									confirmButtonText: "OK!",
									confirmButtonColor: "#6ACF98"
								})
										.then(result => {
											if (result.value) {
												// reset all the migration details back to default
												this.$store.commit("migration/reset");
												if(this.collaboration) {
													location.reload();
												}else{
													this.$router.push({name: "migrationLog"});
												}
											}
										})
							} else {
                await this.addLog({
                  primaryPlan: (typeof this.planIndex === "number") ? this.hostingAccounts[this.planIndex].primary.domain : null,
                  message: `Error in generating tickets for Migration(s): (${cfDomainList.join()})`,
                  level: "error"
                })
								swal({
									title: "Some problem has happened!",
									text: result.data.message,
									type: "error",
									confirmButtonText: "Go back to Migration Details Page",
									confirmButtonColor: "#EE8057",
								})
										.then(result => {
											if (result.value) {
												// reset all the migration details back to default
												this.$store.commit("migration/reset")
												if(this.collaboration){
													location.reload();
													// this.$parent.$parent.changeSection('sites');
												}else{
													this.$router.push({name: "migrationLog"})
												}
											}
										})
							}
						})
						.catch(err => {
              this.addLog({
                primaryPlan: (typeof this.planIndex === "number")? this.hostingAccounts[this.planIndex].primary.domain : null,
                message: `Error in generating tickets for Migration(s): (${cfDomainList.join()})`,
                level: "error"
              })
							// Set asyncDone to true
							this.$store.dispatch("async/stateUpdate", {state: true})

							swal({
								title: "Some problem has happened!",
								text: err.message,
								type: "error",
								confirmButtonText: "Go back to Migration Details Page",
								confirmButtonColor: "#EE8057",
							})
									.then(result => {
										if (result.value) {
											// reset all the migration details back to default
											this.$store.commit("migration/reset")

											if(this.collaboration){
												location.reload();
												// this.$parent.$parent.changeSection('sites');
											}else{
												this.$router.push({name: "migrationLog"})
											}
										}
									})
						})
						.finally(()=>{
							this.$store.dispatch("async/stateUpdate", {state: true});
							this.loading = false;
						})
			}
		}
	};
</script>
<style lang="css">
.fs-20 {
  font-size: 20px;
}
</style>

